import { colors } from 'config/ui'
import {
  childEducationDegreeMap,
  fundamental1DegreeMap,
  fundamental2DegreeMap,
  mediumDegreeMap,
  teacherDegreeMap,
  nonSchoolMap
} from 'utils/degrees'
import type { User, Book, Degree } from 'api/data.types'
import { i18n } from 'i18n'

type badge = {
  name: string
  bgColor: string
  color: string
  fullName?: string
}

export const getBooksBadges = ({
  book,
  user
}: {
  book: Book
  user: User
}): null | badge => {
  const { t } = i18n

  if (!book || !user) {
    return null
  }

  if (nonSchoolMap.includes(book.degree as Degree)) {
    return {
      name: t('EM+'),
      bgColor: colors.red,
      color: colors.white,
      fullName: t('Não escolares')
    }
  }

  if (user.teacher?.blockedBooks?.includes(book.slug)) {
    return {
      name: t('Bloqueado'),
      bgColor: colors.red,
      color: colors.white
    }
  }

  if (
    book.manual_info_checked === false ||
    book.manualInfoChecked === false ||
    teacherDegreeMap.includes(book.degree as Degree)
  ) {
    return {
      name: t('Prof.'),
      bgColor: colors.gray7,
      color: colors.white,
      fullName: t('Técnicos, teóricos e profissionalizantes')
    }
  }

  if (mediumDegreeMap.includes(book.degree as Degree)) {
    return {
      name: t('EM'),
      bgColor: colors.yellow,
      color: colors.white,
      fullName: t('Ensino Médio')
    }
  }

  if (fundamental2DegreeMap.includes(book.degree as Degree)) {
    return {
      name: t('EF2'),
      bgColor: colors.primary,
      color: colors.white,
      fullName: t('Ensino Fundamental 2')
    }
  }

  if (fundamental1DegreeMap.includes(book.degree as Degree)) {
    return {
      name: t('EF1'),
      bgColor: colors.purple,
      color: colors.white,
      fullName: t('Ensino Fundamental 1')
    }
  }

  if (childEducationDegreeMap.includes(book.degree as Degree)) {
    return {
      name: t('EI'),
      bgColor: colors.blue,
      color: colors.white,
      fullName: t('Ensino Infantil')
    }
  }

  if (book.degree === 'G') {
    return {
      name: t('Todos'),
      bgColor: colors.gray7,
      color: colors.white,
      fullName: t('Todos')
    }
  }

  return null
}
